import Conditional from 'decorators/conditional';
import Default from './index.shared';
import Desktop from './index.desktop';

export default Conditional({
  desktop: Desktop,
  default: Default,
});
